import Text from "shared/ui/typography/Text";

const PaymentClientService = () => {
  return (
    <Text className="gg-mt-10 gg-text-sm">
      {
        "Heb je nog vragen of lukt betalen niet? Neem dan even contact met ons op via"
      }{" "}
      <a className={"gg-underline"} href="tel:010 307 2889">
        010 307 2889
      </a>{" "}
      {"of"}{" "}
      <a className={"gg-underline"} href="mailto:klantenservice@gewoongers.nl">
        klantenservice@gewoongers.nl
      </a>
    </Text>
  );
};
export default PaymentClientService;
